"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterTypes = void 0;
var FilterTypes;
(function (FilterTypes) {
    FilterTypes[FilterTypes["log"] = 0] = "log";
    FilterTypes[FilterTypes["block"] = 1] = "block";
    FilterTypes[FilterTypes["pendingTransaction"] = 2] = "pendingTransaction";
})(FilterTypes = exports.FilterTypes || (exports.FilterTypes = {}));
//# sourceMappingURL=filters.js.map